import { render, staticRenderFns } from "./QuestionCreate.vue?vue&type=template&id=69283a98&scoped=true"
import script from "./QuestionCreate.vue?vue&type=script&lang=ts"
export * from "./QuestionCreate.vue?vue&type=script&lang=ts"
import style0 from "./QuestionCreate.vue?vue&type=style&index=0&id=69283a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69283a98",
  null
  
)

export default component.exports